import apiMiddleware from "../../../api/apiMiddleware";

export const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `website-users?page=${page}`
  );
  return response.data;
};

export const search = async ({ search, page = 1 }) => {
  const response = await apiMiddleware.get(
    `website-users?search=${search}&page=${page}`
  );
  return response.data;
};

export const getUserById = async (id) => {
  const response = await apiMiddleware.get(`website-user/${id}`);
  return response.data;
};

// block user
export const blockUser = async (id, status) => {
  const response = await apiMiddleware.post(`block-user/${id}?is_blocked=${status}`);
  return response.data;
};






